(function ($) {
	class W4D_RangeFilter {
		constructor() {
			this.priceGap = 500;
			this.init();
		}

		init() {
			this.$rangeFilters = $('.range-filter');
			this.$rangeFilters.each((index, filter) => this.initializeFilter($(filter)));

			$(document).on('click', '.js-range-reset', () => {
				this.resetFilter();
				W4D_Pagination.fetchProducts();
			});

			this.checkUrlParamsAndUpdate();

			window.addEventListener('popstate', () => {
				this.checkUrlParamsAndUpdate(false);
			});
		}

		initializeFilter($filter) {
			const $rangeValue = $filter.find('.range-filter__slider');
			const rangeInputs = {
				min: $filter.find('.range-filter__range-min'),
				max: $filter.find('.range-filter__range-max'),
			};
			const priceInputs = {
				min: $filter.find('.range-filter__input-min'),
				max: $filter.find('.range-filter__input-max'),
			};

			// Get initial values
			let minPrice = priceInputs.min.data('unformatted-value');
			let maxPrice = priceInputs.max.data('unformatted-value');

			// Set initial values for all inputs
			rangeInputs.min.val(minPrice);
			rangeInputs.max.val(maxPrice);
			priceInputs.min.val(this.formatNumber(minPrice, true)).attr('data-unformatted-value', minPrice);
			priceInputs.max.val(this.formatNumber(maxPrice, true)).attr('data-unformatted-value', maxPrice);

			priceInputs.min.on('focus', (e) => {
				$(e.target).data('previous-value', this.removeCommas($(e.target).val()));
			});
			priceInputs.max.on('focus', (e) => {
				$(e.target).data('previous-value', this.removeCommas($(e.target).val()));
			});

			priceInputs.min.on('blur', (e) => this.handleVisiblePriceInput(e, priceInputs, rangeInputs, $rangeValue));
			priceInputs.max.on('blur', (e) => this.handleVisiblePriceInput(e, priceInputs, rangeInputs, $rangeValue));

			$.each(rangeInputs, (key, $input) => {
				$input.on('mousedown touchstart', (e) => {
					$(e.target).data('previous-value', $(e.target).val());
				});
				$input.on('input', (e) => this.handleRangeInput(e, priceInputs, rangeInputs, $rangeValue));
				$input.on('mouseup touchend', (e) => this.updateURLOnRelease(e, rangeInputs));
			});

			const $control = $filter.find('.range-filter__control');

			// On desktop, Chrome locks onto the target thumb before any pointerdown JS
			// can fire, so z-index changes there are too late. Instead we update z-index
			// continuously on mousemove so the correct thumb is already on top by the
			// time the user clicks.
			$control.on('mousemove', (e) => {
				this.updateThumbZIndex(e.clientX, $control, rangeInputs);
			});

			// For touch there is no hover phase, so pointerdown is still the right
			// moment — touch doesn't have Chrome's pre-capture problem.
			$control.on('touchstart', (e) => {
				const touch = e.originalEvent.touches[0];
				this.updateThumbZIndex(touch.clientX, $control, rangeInputs);
			});

			this.adjustPriceGap(maxPrice);
		}

		// Promote whichever thumb the cursor/finger is closest to.
		updateThumbZIndex(clientX, $control, rangeInputs) {
			const rect = $control[0].getBoundingClientRect();
			const pointerRatio = (clientX - rect.left) / rect.width;

			const minAttr = parseInt(rangeInputs.min.attr('min')) || 0;
			const maxAttr = parseInt(rangeInputs.min.attr('max')) || 10000;

			const minRatio = (parseInt(rangeInputs.min.val()) - minAttr) / (maxAttr - minAttr);
			const maxRatio = (parseInt(rangeInputs.max.val()) - minAttr) / (maxAttr - minAttr);

			const closerToMin = Math.abs(pointerRatio - minRatio) <= Math.abs(pointerRatio - maxRatio);

			rangeInputs.min.css('z-index', closerToMin ? 5 : 4);
			rangeInputs.max.css('z-index', closerToMin ? 4 : 5);
		}

		adjustPriceGap(maxPrice) {
			this.priceGap = Math.ceil(maxPrice * 0.02); // 2% of max Price
		}

		handleVisiblePriceInput(e, priceInputs, rangeInputs, $rangeValue) {
			let minPrice = parseFloat(this.removeCommas(priceInputs.min.val())) || 0;
			let maxPrice = parseFloat(this.removeCommas(priceInputs.max.val())) || 0;
			let priceGap = Math.ceil(maxPrice * 0.02);

			const previousValue = $(e.target).data('previous-value');
			const currentValue = this.removeCommas($(e.target).val());

			// If value hasn't changed, do nothing
			if (previousValue !== undefined && previousValue === currentValue) {
				return;
			}

			// Get the absolute min/max values from the range inputs
			const absoluteMin = parseInt(rangeInputs.min.attr('min')) || 0;
			const absoluteMax = parseInt(rangeInputs.max.attr('max')) || 10000;

			// Enforce absolute minimum
			if (minPrice < absoluteMin) {
				minPrice = absoluteMin;
				priceInputs.min.val(this.formatNumber(minPrice, true));
			}

			// Enforce absolute maximum
			if (maxPrice < absoluteMin || maxPrice > absoluteMax) {
				maxPrice = absoluteMax;
				priceInputs.max.val(this.formatNumber(maxPrice, true));
			}

			if (minPrice > maxPrice - priceGap) {
				minPrice = maxPrice - priceGap;
				priceInputs.min.val(this.formatNumber(minPrice, true));
			}

			rangeInputs.min.val(minPrice);
			rangeInputs.max.val(maxPrice);

			priceInputs.min.attr('data-unformatted-value', minPrice);
			priceInputs.max.attr('data-unformatted-value', maxPrice);

			this.updateRange(minPrice, maxPrice, e.target, rangeInputs, $rangeValue);
			this.toggleSelectedClass(priceInputs.min.closest('.filter'), minPrice, maxPrice);
			this.updateURLWithPriceRange(minPrice, maxPrice);
		}

		handleRangeInput(e, priceInputs, rangeInputs, $rangeValue) {
			let minVal = parseInt(rangeInputs.min.val());
			let maxVal = parseInt(rangeInputs.max.val());
			if (maxVal - minVal < this.priceGap) {
				if (e.target === rangeInputs.min[0]) {
					rangeInputs.min.val(maxVal - this.priceGap);
				} else {
					rangeInputs.max.val(minVal + this.priceGap);
				}
			} else {
				this.updatePriceInputs(minVal, maxVal, priceInputs, rangeInputs, $rangeValue);
			}
		}

		updatePriceInputs(minVal, maxVal, priceInputs, rangeInputs, $rangeValue) {
			priceInputs.min.val(this.formatNumber(minVal, true)).attr('data-unformatted-value', minVal);
			priceInputs.max.val(this.formatNumber(maxVal, true)).attr('data-unformatted-value', maxVal);

			$rangeValue.css({
				left: `${(minVal / rangeInputs.min.attr('max')) * 100}%`,
				right: `${100 - (maxVal / rangeInputs.max.attr('max')) * 100}%`,
			});

			// Keep z-index correct as values shift during dragging, particularly
			// when the min thumb is dragged toward the upper end of the range.
			const minAttr = parseInt(rangeInputs.min.attr('min')) || 0;
			const maxAttr = parseInt(rangeInputs.min.attr('max')) || 10000;
			const minRatio = (minVal - minAttr) / (maxAttr - minAttr);
			const maxRatio = (maxVal - minAttr) / (maxAttr - minAttr);
			const minOnTop = Math.abs(minRatio - 1) < Math.abs(maxRatio - 1);
			rangeInputs.min.css('z-index', minOnTop ? 5 : 4);
			rangeInputs.max.css('z-index', minOnTop ? 4 : 5);

			const $filter = priceInputs.min.closest('.filter');
			this.toggleSelectedClass($filter, minVal, maxVal);
		}

		updateURLOnRelease(e, rangeInputs) {
			const previousValue = $(e.target).data('previous-value');
			const currentValue = $(e.target).val();

			// If value hasn't changed, do nothing
			if (previousValue !== undefined && previousValue === currentValue) {
				return;
			}

			let minPrice = parseInt(rangeInputs.min.val());
			let maxPrice = parseInt(rangeInputs.max.val());
			this.updateURLWithPriceRange(minPrice, maxPrice);
		}

		updateURLWithPriceRange(minPrice, maxPrice) {
			const url = new URL(window.location.href);
			const priceRange = `${minPrice},${maxPrice}`;

			const $filter = $('.filter[data-taxonomy="price"]');
			const defaultMin = parseInt($filter.find('.range-filter__input-min').data('default-value')) || 0;
			const defaultMax = parseInt($filter.find('.range-filter__input-max').data('default-value')) || 10000;

			if (minPrice === defaultMin && maxPrice === defaultMax) {
				url.searchParams.delete('price');
			} else {
				url.searchParams.set('price', priceRange);
			}
			window.history.pushState({}, '', url.toString());
			W4D_Pagination.fetchProducts();
		}

		toggleSelectedClass($filter, minPrice, maxPrice) {
			const $badge = $filter.find('.filter__badge');
			const $inputMin = $filter.find('.range-filter__input-min');
			const $inputMax = $filter.find('.range-filter__input-max');

			const defaultMin = parseInt($inputMin.data('default-value')) || 0;
			const defaultMax = parseInt($inputMax.data('default-value')) || 10000;

			const isSelected = minPrice > defaultMin || maxPrice < defaultMax;

			if (isSelected) {
				const text = `${this.formatNumber(minPrice, false)}-${this.formatNumber(maxPrice, true)}`;
				$badge.text(text).attr('aria-hidden', 'false');
			} else {
				$badge.text('').attr('aria-hidden', 'true');
			}

			const $resetWrapper = $filter.find('.filter__reset-wrapper');
			if ($resetWrapper.length) {
				$resetWrapper.attr('aria-hidden', isSelected ? 'false' : 'true');
			}
		}

		removeCommas(value) {
			return parseInt(value.toString().replace(/\s?€/g, '').replace(/\./g, '') || 0);
		}

		formatNumber(number, includeEuro) {
			return (
				number.toLocaleString('de-DE', {
					minimumFractionDigits: 0,
					maximumFractionDigits: 0,
				}) + (includeEuro ? ' €' : '')
			);
		}

		resetFilter() {
			this.$rangeFilters.each((index, filter) => {
				const $filter = $(filter);
				const $rangeValue = $filter.find('.range-filter__slider');
				const rangeInputs = {
					min: $filter.find('.range-filter__range-min'),
					max: $filter.find('.range-filter__range-max'),
				};
				const priceInputs = {
					min: $filter.find('.range-filter__input-min'),
					max: $filter.find('.range-filter__input-max'),
				};

				const defaultMin = parseInt(rangeInputs.min.attr('min'), 10);
				const defaultMax = parseInt(rangeInputs.max.attr('max'), 10);

				rangeInputs.min.val(defaultMin);
				rangeInputs.max.val(defaultMax);
				priceInputs.min.val(this.formatNumber(defaultMin, true)).attr('data-unformatted-value', defaultMin);
				priceInputs.max.val(this.formatNumber(defaultMax, true)).attr('data-unformatted-value', defaultMax);

				this.updateRange(defaultMin, defaultMax, null, rangeInputs, $rangeValue);

				const $mainFilter = $filter.closest('.filter');
				if ($mainFilter.length) {
					const $badge = $mainFilter.find('.filter__badge');
					$badge.text('').attr('aria-hidden', 'true');

					const $resetWrapper = $mainFilter.find('.filter__reset-wrapper');
					if ($resetWrapper.length) {
						$resetWrapper.attr('aria-hidden', 'true');
					}
				}
			});

			const url = new URL(window.location.href);
			url.searchParams.delete('price');
			window.history.pushState({}, '', url.toString());
		}

		updateRange(minVal, maxVal, target, rangeInputs, $rangeValue) {
			$rangeValue.css({
				left: `${(minVal / rangeInputs.min.attr('max')) * 100}%`,
				right: `${100 - (maxVal / rangeInputs.max.attr('max')) * 100}%`,
			});
		}

		checkUrlParamsAndUpdate(shouldFetchOnInitial = true) {
			const urlParams = new URLSearchParams(window.location.search);
			if (urlParams.has('price')) {
				const [minPrice, maxPrice] = urlParams
					.get('price')
					.split(',')
					.map((price) => parseInt(price, 10));
				this.$rangeFilters.each((index, filter) => {
					const $filter = $(filter);
					const rangeInputs = {
						min: $filter.find('.range-filter__range-min'),
						max: $filter.find('.range-filter__range-max'),
					};
					const priceInputs = {
						min: $filter.find('.range-filter__input-min'),
						max: $filter.find('.range-filter__input-max'),
					};

					priceInputs.min.val(this.formatNumber(minPrice, true)).attr('data-unformatted-value', minPrice);
					priceInputs.max.val(this.formatNumber(maxPrice, true)).attr('data-unformatted-value', maxPrice);

					rangeInputs.min.val(minPrice);
					rangeInputs.max.val(maxPrice);

					const $rangeValue = $filter.find('.range-filter__slider');
					this.updateRange(minPrice, maxPrice, null, rangeInputs, $rangeValue);
					this.toggleSelectedClass($filter.closest('.filter'), minPrice, maxPrice);

					// Only fetch products if price is the only parameter in URL and it's an initial load check
					if (shouldFetchOnInitial && urlParams.toString().split('&').length === 1) {
						W4D_Pagination.fetchProducts();
					}
				});
			} else if (!shouldFetchOnInitial) {
				// If it's a popstate and price is gone, reset to default
				this.$rangeFilters.each((index, filter) => {
					const $filter = $(filter);
					const rangeInputs = {
						min: $filter.find('.range-filter__range-min'),
						max: $filter.find('.range-filter__range-max'),
					};
					const priceInputs = {
						min: $filter.find('.range-filter__input-min'),
						max: $filter.find('.range-filter__input-max'),
					};

					const defaultMin = parseInt(rangeInputs.min.attr('min'), 10);
					const defaultMax = parseInt(rangeInputs.max.attr('max'), 10);

					rangeInputs.min.val(defaultMin);
					rangeInputs.max.val(defaultMax);
					priceInputs.min.val(this.formatNumber(defaultMin, true)).attr('data-unformatted-value', defaultMin);
					priceInputs.max.val(this.formatNumber(defaultMax, true)).attr('data-unformatted-value', defaultMax);

					const $rangeValue = $filter.find('.range-filter__slider');
					this.updateRange(defaultMin, defaultMax, null, rangeInputs, $rangeValue);
					this.toggleSelectedClass($filter.closest('.filter'), defaultMin, defaultMax);
				});
			}
		}
	}

	$(document).ready(function () {
		window.W4D_RangeFilter = new W4D_RangeFilter();
	});
})(jQuery);
